module.exports = __webpack_public_path__ + "img/news.5245575f.svg";